import { defineTokens } from '@chakra-ui/react';

export const tokens = defineTokens({
  colors: {
    gray: {
      25: { value: '#fcfcfd' },
      50: { value: '#f9fafb' },
      100: { value: '#f2f4f7' },
      200: { value: '#eaecf0' },
      300: { value: '#d0d5dd' },
      400: { value: '#98a2b3' },
      500: { value: '#667085' },
      600: { value: '#475467' },
      700: { value: '#344054' },
      800: { value: '#1d2939' },
      900: { value: '#101828' },
      950: { value: '#0c111d' },
    },
    brand: {
      50: { value: '#eff4ff' },
      100: { value: '#d1e0ff' },
      200: { value: '#b2ccff' },
      300: { value: '#84adff' },
      400: { value: '#528bff' },
      500: { value: '#2970ff' },
      600: { value: '#155eef' },
      700: { value: '#004eeb' },
      800: { value: '#0040c1' },
      900: { value: '#00359e' },
    },
    success: {
      50: { value: '#ecfdf3' },
      100: { value: '#d1fadf' },
      300: { value: '#6ce9a6' },
      500: { value: '#12b76a' },
      700: { value: '#027a48' },
    },
    error: {
      50: { value: '#fef3f2' },
      100: { value: '#fee4e2' },
      300: { value: '#fda29b' },
      500: { value: '#f04438' },
      700: { value: '#b42318' },
    },
    warning: {
      50: { value: '#fffaeb' },
      300: { value: '#fec84b' },
      500: { value: '#f79009' },
      700: { value: '#b54708' },
    },
    chart: {
      candleUp: { value: '#2e7d6f' },
      candleDown: { value: '#c4554e' },
    },
  },
  spacing: {
    1: { value: '4px' },
    2: { value: '8px' },
    3: { value: '12px' },
    4: { value: '16px' },
    5: { value: '20px' },
    6: { value: '24px' },
    8: { value: '32px' },
    10: { value: '40px' },
    12: { value: '48px' },
    16: { value: '64px' },
  },
  radii: {
    sm: { value: '6px' },
    md: { value: '8px' },
    lg: { value: '12px' },
    xl: { value: '16px' },
    full: { value: '9999px' },
  },
  shadows: {
    xs: { value: '0 1px 2px rgba(16, 24, 40, 0.05)' },
    sm: { value: '0 1px 3px rgba(16, 24, 40, 0.10), 0 1px 2px rgba(16, 24, 40, 0.06)' },
    md: { value: '0 4px 8px -2px rgba(16, 24, 40, 0.10), 0 2px 4px -2px rgba(16, 24, 40, 0.06)' },
    lg: { value: '0 12px 16px -4px rgba(16, 24, 40, 0.08), 0 4px 6px -2px rgba(16, 24, 40, 0.03)' },
  },
  fonts: {
    body: { value: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" },
    mono: { value: "'SF Mono', 'Cascadia Code', 'Fira Code', 'JetBrains Mono', monospace" },
  },
});
